import { format, parseISO, startOfMonth, subMonths, isValid } from 'date-fns';

export function todayIso(): string {
  return format(new Date(), 'yyyy-MM-dd');
}

export function firstDayOfNextMonth(): string {
  const now = new Date();
  return format(new Date(now.getFullYear(), now.getMonth() + 1, 1), 'yyyy-MM-dd');
}

export function lastMonthToToday(): { start: string; end: string } {
  const now = new Date();
  return {
    start: format(startOfMonth(subMonths(now, 1)), 'yyyy-MM-dd'),
    end: format(now, 'yyyy-MM-dd'),
  };
}

// HTML date input возвращает YYYY-MM-DD, Oracle ожидает DD-MM-YYYY
export function toOracleDate(value: string | null | undefined): string {
  if (!value) return '';
  const d = parseISO(value.slice(0, 10));
  return isValid(d) ? format(d, 'dd-MM-yyyy') : value;
}

export function extractYear(value: string): string {
  const asNumber = parseInt(value, 10);
  if (asNumber >= 1900 && asNumber <= 2099) return String(asNumber);
  const match = value.match(/\b(19|20)\d{2}\b/);
  return match?.[0] ?? value;
}

function parseAnyDate(value: string): Date | null {
  const d = parseISO(value.replace(' ', 'T'));
  return isValid(d) ? d : null;
}

export function formatDateOnly(value: string | null | undefined): string {
  if (!value) return '—';
  const d = parseAnyDate(value);
  return d ? format(d, 'dd.MM.yyyy') : value;
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—';
  const d = parseAnyDate(value);
  if (!d) return value;
  return /[T ]/.test(value) ? format(d, 'dd.MM.yyyy HH:mm') : format(d, 'dd.MM.yyyy');
}
